import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../hooks';
import './Paper.scss';
export const Paper = ({ p = 'md', ...props }) => {
    const className = useClassName({ name: 'paper', prefixed: true }, p && `p-${p}`);
    return _jsx("div", { className: className, ...props });
};
